import { Progress as ProgressPrimitive } from '@base-ui/react/progress';

import { cn } from '@/lib/utils';

export type ProgressLabelProps = ProgressPrimitive.Label.Props;

const ProgressLabel = ({ className, ...props }: ProgressLabelProps) => {
  return (
    <ProgressPrimitive.Label
      className={cn('text-sm font-medium', className)}
      data-slot="progress-label"
      {...props}
    />
  );
};

export default ProgressLabel;
